import { Box, Typography } from '@mui/material';

import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import React from 'react';
import { Routes } from 'src/utils/enums';
import { StyledNormalButton } from 'src/styledComponents/styledButtons';
import TechnologyFooter from '../../components/heroSection/technologiesFooter';
import TransitionText from '../../components/heroSection/transitionText';
import { content } from 'src/common/lang/en-US';
import { getWorldMap } from 'src/resources/svgs/worldMap';
import { useNavigate } from 'react-router-dom';

const HomePage: React.FC = () => {
    const worldMap = getWorldMap('"rgba(115, 201, 216, 0.20)"'); // can be changed based on the theme
    const encodedWorldMap = `data:image/svg+xml;base64,${btoa(worldMap)}`;
    const navigate = useNavigate();

    return (
        <Box
            display="flex"
            flexDirection="column"
            minWidth="100%"
            sx={{
                '@media (min-width: 2560px)': {
                    backgroundPosition: 'center 2rem',
                    backgroundSize: '60%',
                },
                backgroundAttachment: 'scroll',
                backgroundImage: `url(${encodedWorldMap})`,
                backgroundPosition: {
                    lg: '20rem 1rem',
                    md: '6rem 1rem',
                    sm: '4rem 1rem',
                    xl: 'center top',
                    xs: 'center top',
                },
                backgroundRepeat: 'no-repeat',
                backgroundSize: {
                    lg: 'contain',
                    md: 'contain',
                    sm: 'contain',
                    xl: '80%',
                    xs: 'cover',
                },
            }}
        >
            <Box
                alignSelf="center"
                display="flex"
                flexDirection="column"
                flexGrow={1}
                marginTop="170px"
                paddingX={{ lg: '10rem', md: '5rem', sm: '3rem', xs: '2rem' }}
                sx={{
                    '@media (min-width: 2560px)': {
                        paddingX: '20rem',
                    },
                    paddingX: {
                        lg: '10rem',
                        md: '5rem',
                        sm: '3rem',
                        xl: '16rem',
                        xs: '2rem',
                    },
                }}
            >
                <Typography variant="h1">{content.homePage.homePageTitle}</Typography>
                <Box marginTop="1.5rem">
                    <TransitionText
                        color="textSecondary"
                        constantTextAfter="your business"
                        constantTextBefore="Partner with us to"
                        interval={4000}
                        transitionTextColor="primary.main"
                        transitionTexts={['Create', 'Innovate', 'Elevate', 'Grow']}
                        variant="subtitle1"
                    />
                </Box>
                <Box display="flex" flexWrap={'wrap'} gap={2} marginTop={3}>
                    <StyledNormalButton onClick={() => navigate(Routes.CONTACT_US)} variant="contained">
                        <Typography
                            onClick={() => {
                                navigate(Routes.CONTACT_US);
                            }}
                            paddingRight="0.5rem"
                            sx={{ whiteSpace: 'nowrap' }}
                            variant="body2"
                        >
                            Get In Touch
                        </Typography>
                        <ArrowOutwardIcon />
                    </StyledNormalButton>
                    <StyledNormalButton
                        color="info"
                        onClick={() => {
                            navigate(Routes.ABOUT);
                        }}
                        variant="outlined"
                    >
                        <Typography color="text.secondary" sx={{ whiteSpace: 'nowrap' }} variant="body2">
                            About Us
                        </Typography>
                    </StyledNormalButton>
                </Box>
            </Box>
            <Box mt={{ md: 10, sm: 8, xs: 6 }} sx={{ '@media (min-width: 2560px)': { mt: 14 } }}>
                <TechnologyFooter />
            </Box>
        </Box>
    );
};

export default HomePage;
